import { Tooltip } from 'antd'
import { Icon } from '@iconify/react'

import styles from '../../ProjectStoryMapBoard.module.css'

const InsertZone = ({
    onClick,
    label,
    variant = 'step',
    style,
    gapSplitStyle,
    className = '',
    dataAfter,
}) => (
    <div
        className={`${styles.insertZone} ${styles.columnGapSplit} ${
            variant === 'journey' ? styles.insertZoneJourney : styles.insertZoneStep
        } ${className}`.trim()}
        style={{ ...style, ...gapSplitStyle }}
        data-after={dataAfter}
    >
        <div className={styles.insertZoneTrack} aria-hidden="true" />
        <Tooltip title={label} placement="top">
            <button
                type="button"
                className={styles.insertZoneBtn}
                onClick={onClick}
                aria-label={label}
            >
                <Icon icon="mdi:plus" width={12} />
            </button>
        </Tooltip>
        {variant === 'journey' ? (
            <span className={styles.insertZoneLabel}>{label}</span>
        ) : null}
    </div>
)

export default InsertZone
